import styled, { css } from "styled-components";
import { activeColor, color, hoverColor, onHover, snap, typeStyle, units, variant } from "@m/alchemy-theme";
import { NakedButton } from "../naked-button/NakedButton";
import { LiveRegionAlert } from "../utilities/live-region/LiveRegionAlert";
export const MessageBanner = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  color: ${color("typeBody")};
  max-height: ${snap(200)};
  padding: ${variant("size", {
    small: `${units(1.5)} ${units(2)}`,
    default: `${units(1.25)} ${units(3)}`
})};
  background-color: ${color("hint")};
  ${typeStyle("bodyL")};

  a {
    color: ${color("contrast")};
    text-decoration: none;

    ${onHover(css `
      color: ${hoverColor("contrast")};
      text-decoration: underline;
    `)}

    &:active {
      color: ${activeColor("contrast")};
      text-decoration: underline;
    }
  }
`;
export const Alert = styled(LiveRegionAlert) `
  display: flex;
  align-items: inherit;
  justify-content: inherit;
`;
export const IconWrapper = styled.div `
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  color: ${color("base")};
  border-radius: 50%;
  margin-right: ${units(1.5)};

  svg {
    height: ${({ size }) => (size === "small" ? units(2) : units(3))};
    width: ${({ size }) => (size === "small" ? units(2) : units(3))};
  }
`;
export const Title = styled.strong `
  color: ${({ activeColorScheme }) => (activeColorScheme === "alchemyBrand" ? color("contrast") : color("typeBody"))};
  ${({ size }) => (size === "small" ? typeStyle("bodyM") : typeStyle("subHeaderM"))};
  margin-right: ${units(0.5)};
`;
export const Content = styled.div `
  color: ${({ activeColorScheme }) => (activeColorScheme === "alchemyBrand" ? color("contrast") : color("typeBody"))};
  ${({ size }) => (size === "small" ? typeStyle("bodyS") : typeStyle("bodyL"))};
  margin-right: ${units(1.5)};
  width: 100%;
`;
export const DismissButton = styled(NakedButton) `
  margin-left: auto;
  padding: 0;

  svg {
    color: currentColor;
  }

  ${onHover(css `
    color: ${hoverColor("base")};
  `)}

  &:active {
    color: ${activeColor("base")};
  }
`;
